import React from "react";
import { StyledTooltip } from "./styled";

export const ContexualHelp = ({
  children,
  title = "",
  placement = window.innerWidth < 600 ? "top" : "left",
  isDisableHoverListener = true,
  dataTestId = "contexual-help",
  ...props
}) => {
  if (!title) {
    return children;
  }

  return (
    <StyledTooltip
      disableHoverListener={isDisableHoverListener}
      placement={placement}
      title={title}
      enterTouchDelay={0}
      leaveTouchDelay={10000}
      leaveDelay={0}
      data-testid={dataTestId}
      arrow={true}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};
